import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'

import PDCButton from 'pdc-button'
import MainImage from '../images/main-image.jpg'
import TextField from '@material-ui/core/es/TextField/TextField'

import API from '../util/api_v5'

const styles = theme => ({
	wrapper: {
		fontFamily: 'Montserrat',
		marginTop: 45,
		display: 'flex'
	},
	mainContent: {
		flex: 1
	},
	imageContent: {
		flex: 1,
		'& img': {
			width: '100%'
		}
	},
	mainMessage: {
		fontSize: 14,
		fontWeight: 600,
		lineHeight: 1.38,
		letterSpacing: -0.1,
		marginBottom: 20
	},
	secondaryMessage: {
		fontSize: 12,
		lineHeight: 1.43
	},
	pricingDetailsLink: {
		color: theme.palette.primary.main
	},
	separator: {
		border:			'none',
		borderTop:		'1px solid',
		marginTop:		25,
		marginBottom:	30,
		borderColor:	theme.meetingsAdminApp.separatorColor
	},
	nameUrlInputs: {
		display: 'flex'
	},
	businessNameInput: {
		marginLeft: 15
	},
	meetUrlField: {
		marginLeft: 30,
		display: 'flex',
		background: 'rgba(0, 0, 0, 0.09)',
		borderRadius: 4
	},
	meetUrlInput: {
		border: 'none',
		padding: '0 10px',
		background: 'transparent',
		outline: 'none'
	},
	urlStyle: {
		display: 'flex',
		alignItems: 'center',
		padding: '0 10px'
	},
	enableMeetsButtonStyle: {
		marginTop:			41,
		color:				'white',
		border:				'none',
		backgroundColor:	theme.palette.primary.main,
		'&:hover': {
			border: 'none'
		}
	},
	headerStyle: {
		fontWeight: 700,
		paddingTop:30
	},
	titleHeaderStyle: {
		marginBottom: 25,
	},
	largeTitleStyle: {
		fontWeight:		700,
		fontSize:		30,
		lineHeight:		1.13,
		letterSpacing:	-0.5
	},
	freeMessage: {
		color:			theme.palette.primary.main,
		marginBottom:	10
	}
})

class EnableMeetings extends Component {

	state = {
		domainStateErrorText:		'',
		businessNameStateErrorText:	''
	}

	enableMeeting = async () => {
		if (this.state.domainStateErrorText) this.setState({domainStateErrorText: '', businessNameStateErrorText: ''})

		if (!this.props.businessNameEntry || this.props.businessNameEntry.replace(' ', '') === '') {
			this.setState({ businessNameStateErrorText: 'Business Name can not be empty' })
			return
		}
		if (!this.props.domainEntry || this.props.domainEntry.replace(' ', '') === '') {
			this.setState({domainStateErrorText: 'Url can not be empty'})
			return
		}

		this.props.setEnablingMeetings(true)

		let response = await API.enableConfig(true, this.props.domainEntry, this.props.businessNameEntry)
		console.log(response)
		if (response) {
			this.props.setMeetingsEnabled(response.enabled)
		} else {
			this.props.setMeetingsEnabled(false)
			this.setState({domainStateErrorText: 'Meeting url already taken'})
		}
		this.props.setEnablingMeetings(false)
	}

	handleBusinessNameEntryChange = event => {
		this.props.updateBusinessNameEntry(event.target.value)
		this.props.changeDomainEntry(event.target.value)
	}

	handleDomainEntryChange = event => this.props.changeDomainEntry(event.target.value)

	render() {
		const { classes } = this.props
		return (
			<div className={classes.wrapper}>
				<div className={classes.mainContent}>
					<div className={`${classes.titleHeaderStyle} ${classes.largeTitleStyle} ${classes.headerStyle}`}>VIDEO MEETINGS</div>
					<div className={classes.mainMessage}>
						Introducing our new video conferencing and screen sharing solution. Now you can collaborate from anywhere using your personal computer.
					</div>
					<div className={`${classes.largeTitleStyle} ${classes.freeMessage}`}>
						FREE through May 31st
					</div>
					<div className={classes.secondaryMessage}>
						In order to help organizations practice physical distancing by transitioning to remote work, we are offering the use of our video collaboration solution free for the first two months. There’s no obligation, no initial payment required, and you can cancel anytime. &nbsp;
						<a
							className	= {classes.pricingDetailsLink}
							href		= 'https://www.phone.com/features/video-conferencing-service/'
							target		= '_blank'
						>
							Find pricing details and more information here
						</a>.
					</div>

					<hr className={classes.separator}/>

					<div className={classes.nameUrlInputs}>
						<TextField
							onChange	= {this.handleBusinessNameEntryChange}
							value		= {this.props.businessNameEntry}
							disabled	= {this.props.enablingMeetings}
							error		= {Boolean(this.state.businessNameStateErrorText)}
							helperText	= {this.state.businessNameStateErrorText}
							className	= {classes.businessNameInput}
							id			= 'standard-basic'
							label		= 'Business Name'
						/>
						<div className={classes.meetUrlField}>
							<input
								type		= 'text'
								value		= {this.props.domainEntry}
								onChange	= {this.handleDomainEntryChange}
								disabled	= {this.props.enablingMeetings}
								className	= {classes.meetUrlInput}
							/>
							<span className={classes.urlStyle}>.meet.phone.com</span>
						</div>
					</div>

					<PDCButton
						onClick		= {this.enableMeeting}
						disabled	= {this.props.enablingMeetings}
						variant		= 'outlined'
						className	= {classes.enableMeetsButtonStyle}
					>
						Start my free trial
					</PDCButton>
				</div>
				<div className={classes.imageContent}>
					<img src={MainImage} alt='img' />
				</div>
			</div>
		)
	}
}

export default withStyles(styles)(EnableMeetings)